// extracted by mini-css-extract-plugin
module.exports = {"home":"home_home__3gHdI","homeSubtitle":"home_homeSubtitle__1Xgcm","homeTitle":"home_homeTitle__1sIsg","homeText":"home_homeText__2l0nC","banner":"home_banner__2SymO"};